// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"f8f6aa73","163":"191a5bf8","213":"75438b87","239":"8fc453bc","267":"5fa33b45","362":"f9f78d30","455":"a53e9619","687":"ce08922a","879":"b20a7125","944":"08816046","950":"df18aa7a"}[chunkId] + ".chunk.js";
};